export interface MarketReportStatistic {
  name: MarketReportStatisticType;
  value: string;
  position: number;
}

export enum MarketReportStatisticType {
  activeListings = 'ActiveListings',
  soldListings = 'SoldListings',
  leasedListings = 'LeasedListings',
  totalRecommendations = 'TotalRecommendations',
  averageSalePrice = 'AverageSalePrice',
  totalSalePrice = 'TotalSalePrice',
  averageStarRating = 'AverageStarRating',
}
